module.exports = __webpack_public_path__ + "static/img/1.9e7ce85.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/5/1/sp/1.png
// module id = UKnn
// module chunks = 0